import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var sessionToken = require("../constants/credentials");
var Parse = require("parse");

/**
 * Contains functions for calling and declaring
 *
 * @class Jobin.Guild
 * @static
 * @hideconstructor
 */

/**
 * Download a specific guild
 * @method get
 * @name Jobin.Guild.get
 * @param {string} id vertical Id
 * @returns {Parse.Object} Vertical fetched
 */
export function get(_x) {
  return _get.apply(this, arguments);
}
/**
 * Download a specific guild with top father 
 * @method getWhitFather
 * @name Jobin.Guild.getWhitFather
 * @param {string} id vertical Id
 * @returns {Parse.Object} Vertical fetched
 */
function _get() {
  _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return new Parse.Query("Verticales").include("Father").get(id);
        case 3:
          _context.t0 = _context.sent;
          return _context.abrupt("return", {
            status: "ok",
            result: _context.t0
          });
        case 7:
          _context.prev = 7;
          _context.t1 = _context["catch"](0);
          console.error(_context.t1);
          return _context.abrupt("return", {
            status: "error",
            result: "Hubo un error y no hemos podido descargar la vertical. Inténtalo de nuevo más tarde"
          });
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _get.apply(this, arguments);
}
export function getWhitFather(_x2) {
  return _getWhitFather.apply(this, arguments);
}
/**
 * Download guild fathers and his first childs
 * @method getAll
 * @name Jobin.Guild.getAll
 * @returns {Array} Vertical ParseObject.
 */
function _getWhitFather() {
  _getWhitFather = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id) {
    var guild, topFather, currentGuildId, currentGuild;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return new Parse.Query("Verticales").include("Father").get(id);
        case 3:
          guild = _context2.sent;
          topFather = null;
          currentGuildId = id;
        case 6:
          if (!(topFather == null)) {
            _context2.next = 13;
            break;
          }
          _context2.next = 9;
          return new Parse.Query("Verticales").include("Father").include("Image").get(currentGuildId);
        case 9:
          currentGuild = _context2.sent;
          if (currentGuild.get("Father")) {
            currentGuildId = currentGuild.get("Father").id;
          } else {
            topFather = currentGuild;
          }
          _context2.next = 6;
          break;
        case 13:
          _context2.next = 15;
          return new Parse.Query("Verticales").include("Father").get(id);
        case 15:
          _context2.t0 = _context2.sent;
          _context2.t1 = topFather;
          _context2.t2 = {
            guild: _context2.t0,
            topFather: _context2.t1
          };
          return _context2.abrupt("return", {
            status: "ok",
            result: _context2.t2
          });
        case 21:
          _context2.prev = 21;
          _context2.t3 = _context2["catch"](0);
          console.error(_context2.t3);
          return _context2.abrupt("return", {
            status: "error",
            result: "Hubo un error y no hemos podido descargar la vertical. Inténtalo de nuevo más tarde"
          });
        case 25:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 21]]);
  }));
  return _getWhitFather.apply(this, arguments);
}
export function getAll() {
  return _getAll.apply(this, arguments);
}
/**
 * Download guild fathers
 * @method getFathers
 * @name Jobin.Guild.getFathers
 * @returns {Array} Vertical ParseObject.
 */
function _getAll() {
  _getAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var Verticales, query1, query2, query3;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          Verticales = Parse.Object.extend("Verticales");
          query1 = new Parse.Query(Verticales);
          query1.doesNotExist("Father");
          query1.equalTo("Active", true);
          query2 = new Parse.Query(Verticales);
          query2.matchesQuery("Father", query1);
          query2.equalTo("Active", true);
          query3 = Parse.Query.or(query1, query2);
          query3.include("Father");
          query3.ascending("Position");
          _context3.prev = 10;
          _context3.next = 13;
          return query3.find();
        case 13:
          _context3.t0 = _context3.sent;
          return _context3.abrupt("return", {
            status: "ok",
            result: _context3.t0
          });
        case 17:
          _context3.prev = 17;
          _context3.t1 = _context3["catch"](10);
          console.error(_context3.t1);
          return _context3.abrupt("return", {
            status: "error",
            result: "Hubo un error y no hemos podido descargar las verticales disponibles en Jobin. Inténtalo de nuevo más tarde"
          });
        case 21:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[10, 17]]);
  }));
  return _getAll.apply(this, arguments);
}
export function getFathers() {
  return _getFathers.apply(this, arguments);
}
/**
 * Download guild fathers
 * @method getFathers
 * @name Jobin.Guild.getFathers
 * @returns {Array} Vertical ParseObject.
 */
function _getFathers() {
  _getFathers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var Verticales, query;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          Verticales = Parse.Object.extend("Verticales");
          query = new Parse.Query(Verticales);
          query.doesNotExist("Father");
          query.equalTo("Active", true);
          query.ascending("Position");
          _context4.prev = 5;
          _context4.next = 8;
          return query.find();
        case 8:
          _context4.t0 = _context4.sent;
          return _context4.abrupt("return", {
            status: "ok",
            result: _context4.t0
          });
        case 12:
          _context4.prev = 12;
          _context4.t1 = _context4["catch"](5);
          console.error(_context4.t1);
          return _context4.abrupt("return", {
            status: "error",
            result: "No hemos podido descargar las verticales padre."
          });
        case 16:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[5, 12]]);
  }));
  return _getFathers.apply(this, arguments);
}
export function getChildsFather(_x3) {
  return _getChildsFather.apply(this, arguments);
}
/**
 * Download all the verticals for the explore view in one shot
 * @method getForExplore
 * @name Jobin.Guild.getForExplore
 * @returns {Array} Vertical ParseObject.
 */
function _getChildsFather() {
  _getChildsFather = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(child) {
    var father, Verticales, query;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          father = child.get("Father");
          if (!father) {
            _context5.next = 18;
            break;
          }
          Verticales = Parse.Object.extend("Verticales");
          query = new Parse.Query(Verticales);
          query.equalTo("objectId", father.id);
          _context5.prev = 5;
          _context5.next = 8;
          return query.first();
        case 8:
          _context5.t0 = _context5.sent;
          return _context5.abrupt("return", {
            status: "ok",
            result: _context5.t0
          });
        case 12:
          _context5.prev = 12;
          _context5.t1 = _context5["catch"](5);
          console.error(_context5.t1);
          return _context5.abrupt("return", {
            status: "error",
            result: "No hemos podido descargar el padre de esta vertical."
          });
        case 16:
          _context5.next = 19;
          break;
        case 18:
          return _context5.abrupt("return", {
            status: "error",
            result: "Esta vertical no tiene padre."
          });
        case 19:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[5, 12]]);
  }));
  return _getChildsFather.apply(this, arguments);
}
export function getForExplore() {
  return _getForExplore.apply(this, arguments);
}
/**
 * Download guilds with fixed price matching the postal code
 * @method getFatherChilds
 * @name Jobin.Guild.getFatherChilds
 * @param {Parse.Object|string} father
 * @param {boolean} showInactive
 * @returns {Array} Vertical ParseObject.
 */
function _getForExplore() {
  _getForExplore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var DeveloperMarks, query, positionMark, sectionArray, tempArray, i, obj, query2, result, orderSectionArray, finalArray, _i, mark, guildArray, tempArray3, _i2, _obj, Verticales, query3, _result, orderGuildArray, markObj;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          DeveloperMarks = Parse.Object.extend("DeveloperMarks");
          query = new Parse.Query(DeveloperMarks);
          query.equalTo("MarkType", "GuildsPosition");
          _context6.prev = 3;
          _context6.next = 6;
          return query.first();
        case 6:
          positionMark = _context6.sent;
          sectionArray = positionMark.get("Array"); //Get the ids
          tempArray = [];
          for (i = 0; i < sectionArray.length; i++) {
            obj = sectionArray[i];
            tempArray.push(obj.id);
          } //Search the developer marks
          query2 = new Parse.Query(DeveloperMarks);
          query2.containedIn("objectId", tempArray);
          _context6.prev = 12;
          _context6.next = 15;
          return query2.find();
        case 15:
          result = _context6.sent;
          orderSectionArray = reorderGuildArray(sectionArray, result);
          finalArray = []; //get the object for each section
          _i = 0;
        case 19:
          if (!(_i < orderSectionArray.length)) {
            _context6.next = 45;
            break;
          }
          mark = orderSectionArray[_i];
          guildArray = mark.get("Array"); //Get the ids
          tempArray3 = [];
          for (_i2 = 0; _i2 < guildArray.length; _i2++) {
            _obj = guildArray[_i2];
            tempArray3.push(_obj.id);
          }
          Verticales = Parse.Object.extend("Verticales");
          query3 = new Parse.Query(Verticales);
          query3.containedIn("objectId", tempArray3);
          query3.equalTo("Active", true);
          if (mark.get("MarkType") === "GuildsFixed") {
            query3.exists("Price.fixed.default");
          }
          _context6.prev = 29;
          _context6.next = 32;
          return query3.find();
        case 32:
          _result = _context6.sent;
          orderGuildArray = reorderGuildArray(guildArray, _result);
          markObj = mark.get("Object");
          finalArray.push({
            object: markObj,
            section: mark.get("MarkType"),
            guildArray: orderGuildArray
          });
          _context6.next = 42;
          break;
        case 38:
          _context6.prev = 38;
          _context6.t0 = _context6["catch"](29);
          console.error(_context6.t0);
          return _context6.abrupt("return", {
            status: "error",
            result: "Hubo un error al cargar el contenido de Jobin. Inténtalo de nuevo más tarde."
          });
        case 42:
          _i++;
          _context6.next = 19;
          break;
        case 45:
          return _context6.abrupt("return", {
            status: "ok",
            result: finalArray
          });
        case 48:
          _context6.prev = 48;
          _context6.t1 = _context6["catch"](12);
          console.error(_context6.t1);
          return _context6.abrupt("return", {
            status: "error",
            result: "Hubo un error al cargar el contenido de Jobin. Inténtalo de nuevo más tarde."
          });
        case 52:
          _context6.next = 58;
          break;
        case 54:
          _context6.prev = 54;
          _context6.t2 = _context6["catch"](3);
          console.error(_context6.t2);
          return _context6.abrupt("return", {
            status: "error",
            result: "Hubo un error al cargar el contenido de Jobin. Inténtalo de nuevo más tarde."
          });
        case 58:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[3, 54], [12, 48], [29, 38]]);
  }));
  return _getForExplore.apply(this, arguments);
}
export function getFatherChilds(_x4) {
  return _getFatherChilds.apply(this, arguments);
}
/**
 * Download guilds fixed extras
 * @method getPrevExtras
 * @name Jobin.Guild.getPrevExtras
 * @param {ParseObject} guild
 * @param {int} position optional
 * @returns {Array} FixedExtras ParseObject.
 */
function _getFatherChilds() {
  _getFatherChilds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(father) {
    var showInactive,
      query,
      _args7 = arguments;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          showInactive = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : false;
          if (typeof father === "string") father = Parse.Object.extend("Verticales").createWithoutData(father);
          query = new Parse.Query("Verticales");
          query.equalTo("Father", father);
          if (!showInactive) query.equalTo("Active", true);
          query.ascending("Position");
          _context7.prev = 6;
          _context7.next = 9;
          return query.find();
        case 9:
          _context7.t0 = _context7.sent;
          return _context7.abrupt("return", {
            status: "ok",
            result: _context7.t0
          });
        case 13:
          _context7.prev = 13;
          _context7.t1 = _context7["catch"](6);
          console.error(_context7.t1);
          return _context7.abrupt("return", {
            status: "error",
            result: "Ocurrió un error al descargar las verticales hijo."
          });
        case 17:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[6, 13]]);
  }));
  return _getFatherChilds.apply(this, arguments);
}
export function getPrevExtras(_x5, _x6) {
  return _getPrevExtras.apply(this, arguments);
}
/**
 * Download guilds fixed extras
 * @method getExtras
 * @name Jobin.Guild.getExtras
 * @param {ParseObject} guild
 * @returns {Array} FixedExtras ParseObject.
 */
function _getPrevExtras() {
  _getPrevExtras = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(guild, position) {
    var prevExtras, tempArray, FixedExtra, query;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          prevExtras = guild.get("PrevExtras");
          if (!(prevExtras && prevExtras.length > 0)) {
            _context8.next = 28;
            break;
          }
          //Get the ids from all the prevExtras or only for one position
          tempArray = [];
          if (!(position !== undefined)) {
            _context8.next = 11;
            break;
          }
          if (!(position < prevExtras.length && position >= 0)) {
            _context8.next = 8;
            break;
          }
          tempArray = prevExtras[position].extras;
          _context8.next = 9;
          break;
        case 8:
          return _context8.abrupt("return", {
            status: "error",
            result: "La posición proporcionada no pertenece al array de posiciones"
          });
        case 9:
          _context8.next = 12;
          break;
        case 11:
          prevExtras.map(function (item) {
            item.extras.map(function (extra) {
              tempArray.push(extra);
            });
          });
        case 12:
          FixedExtra = Parse.Object.extend("FixedExtra");
          query = new Parse.Query(FixedExtra);
          query.containedIn("objectId", tempArray);
          _context8.prev = 15;
          _context8.next = 18;
          return query.find();
        case 18:
          _context8.t0 = _context8.sent;
          return _context8.abrupt("return", {
            status: "ok",
            result: _context8.t0
          });
        case 22:
          _context8.prev = 22;
          _context8.t1 = _context8["catch"](15);
          console.error(_context8.t1);
          return _context8.abrupt("return", {
            status: "error",
            result: "Hubo un error al descargar los extras de este trabajo a precio cerrado."
          });
        case 26:
          _context8.next = 29;
          break;
        case 28:
          return _context8.abrupt("return", {
            status: "ok",
            result: null
          });
        case 29:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[15, 22]]);
  }));
  return _getPrevExtras.apply(this, arguments);
}
export function getExtras(_x7) {
  return _getExtras.apply(this, arguments);
}
/**
 * Download guild with id
 * @method getFromId
 * @name Jobin.Guild.getFromId
 * @returns {ParseObject} Vertical ParseObject.
 */
function _getExtras() {
  _getExtras = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(guild) {
    var extrasArray, FixedExtra, query;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          if (!(typeof guild === "string")) {
            _context9.next = 4;
            break;
          }
          _context9.next = 3;
          return new Parse.Query("Verticales").get(guild);
        case 3:
          guild = _context9.sent;
        case 4:
          extrasArray = guild.get("Extras");
          if (!extrasArray) {
            _context9.next = 22;
            break;
          }
          FixedExtra = Parse.Object.extend("FixedExtra");
          query = new Parse.Query(FixedExtra);
          query.containedIn("objectId", extrasArray);
          _context9.prev = 9;
          _context9.next = 12;
          return query.find();
        case 12:
          _context9.t0 = _context9.sent;
          return _context9.abrupt("return", {
            status: "ok",
            result: _context9.t0
          });
        case 16:
          _context9.prev = 16;
          _context9.t1 = _context9["catch"](9);
          console.error(_context9.t1);
          return _context9.abrupt("return", {
            status: "error",
            result: "Hubo un error al descargar los extras de este trabajo a precio cerrado."
          });
        case 20:
          _context9.next = 23;
          break;
        case 22:
          return _context9.abrupt("return", {
            status: "ok",
            result: null
          });
        case 23:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[9, 16]]);
  }));
  return _getExtras.apply(this, arguments);
}
export function getFromId(_x8) {
  return _getFromId.apply(this, arguments);
}
/**
 * Search guild objects matching the search string
 * @method searchWithString
 * @name Jobin.Guild.searchWithString
 * @param {string} url
 * @param {string} searchText
 * @param {string} jobinApiKey
 * @param {boolean} includeInactive
 * @returns {Array} Vertical ParseObject.
 */
function _getFromId() {
  _getFromId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(guildId) {
    var Verticales, query;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          Verticales = Parse.Object.extend("Verticales");
          query = new Parse.Query(Verticales);
          query.equalTo("objectId", guildId);
          _context10.prev = 3;
          _context10.next = 6;
          return query.first();
        case 6:
          _context10.t0 = _context10.sent;
          return _context10.abrupt("return", {
            status: "ok",
            result: _context10.t0
          });
        case 10:
          _context10.prev = 10;
          _context10.t1 = _context10["catch"](3);
          console.error(_context10.t1);
          return _context10.abrupt("return", {
            status: "error",
            result: "No hemos podido descargar la vertical."
          });
        case 14:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[3, 10]]);
  }));
  return _getFromId.apply(this, arguments);
}
export function searchWithString() {
  return _searchWithString.apply(this, arguments);
}
/**
 * Search guild objects matching the search string
 * @method getStores
 * @name Jobin.Guild.getStores
 * @returns {Array} Stores associated with Guilds object.
 */
function _searchWithString() {
  _searchWithString = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    var url,
      searchText,
      jobinApiKey,
      includeInactive,
      response,
      _args11 = arguments;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          url = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : "https://api.jobin.es/v1";
          searchText = _args11.length > 1 ? _args11[1] : undefined;
          jobinApiKey = _args11.length > 2 ? _args11[2] : undefined;
          includeInactive = _args11.length > 3 && _args11[3] !== undefined ? _args11[3] : false;
          if (!(searchText.length > 1)) {
            _context11.next = 26;
            break;
          }
          _context11.prev = 5;
          _context11.next = 8;
          return fetch("".concat(url, "/services?s=").concat(searchText, "&key=").concat(jobinApiKey, "&inactive=").concat(includeInactive));
        case 8:
          response = _context11.sent;
          _context11.prev = 9;
          _context11.next = 12;
          return response.json();
        case 12:
          _context11.t0 = _context11.sent;
          return _context11.abrupt("return", {
            status: "ok",
            result: _context11.t0
          });
        case 16:
          _context11.prev = 16;
          _context11.t1 = _context11["catch"](9);
          console.error(_context11.t1);
          return _context11.abrupt("return", {
            status: "error",
            result: "Hubo un error al realizar la búsqueda"
          });
        case 20:
          _context11.next = 26;
          break;
        case 22:
          _context11.prev = 22;
          _context11.t2 = _context11["catch"](5);
          console.error(_context11.t2);
          return _context11.abrupt("return", {
            status: "error",
            result: "Hubo un error al realizar la búsqueda"
          });
        case 26:
          return _context11.abrupt("return", {
            status: "ok",
            result: null
          });
        case 27:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[5, 22], [9, 16]]);
  }));
  return _searchWithString.apply(this, arguments);
}
export function getStores() {
  return _getStores.apply(this, arguments);
}
function _getStores() {
  _getStores = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    var currentUser, stores, results, formattedResult;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return Parse.User.currentAsync();
        case 2:
          currentUser = _context12.sent;
          if (!(currentUser || sessionToken.getToken())) {
            _context12.next = 19;
            break;
          }
          stores = new Parse.Query(Parse.Object.extend("Verticales")).exists("Location").include(["Father", "Father.Father"]).ascending("Position").select("Type", "Father.Type", "Father.Father.Type");
          _context12.prev = 5;
          _context12.next = 8;
          return stores.find();
        case 8:
          results = _context12.sent;
          formattedResult = results.map(function (result) {
            var name = result.has("Father") && result.get("Father").has("Father") ? result.get("Father").get("Father").get("Type") + " - " + result.get("Type") : result.has("Father") ? result.get("Father").get("Type") + " - " + result.get("Type") : result.get("Type");
            return {
              id: result.id,
              name: name
            };
          });
          return _context12.abrupt("return", {
            status: "ok",
            result: formattedResult
          });
        case 13:
          _context12.prev = 13;
          _context12.t0 = _context12["catch"](5);
          console.error(_context12.t0);
          return _context12.abrupt("return", {
            status: "error",
            result: "No hemos podido obtener las tiendas"
          });
        case 17:
          _context12.next = 20;
          break;
        case 19:
          return _context12.abrupt("return", {
            status: "error",
            result: "No tienes permisos para hacer esta petición."
          });
        case 20:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[5, 13]]);
  }));
  return _getStores.apply(this, arguments);
}
function reorderGuildArray(orderArray, guildArray) {
  var tempArray = [];
  for (var i = 0; i < orderArray.length; i++) {
    var obj = orderArray[i];
    for (var j = 0; j < guildArray.length; j++) {
      var guild = guildArray[j];
      if (obj.id === guild.id) {
        tempArray.push(guild);
      }
    }
  }
  return tempArray;
}
/**
 * Get all reviews based on guild or subguild.
 * @method getGuildReviews
 * @name Jobin.Jober.getGuildReviews
 * @param {ParseObject} jober (optional)
 * @returns {Array} All Jober reviews.
 */

export function getGuildReviews(_x9) {
  return _getGuildReviews.apply(this, arguments);
}
/**
 * Get all reviews based on guild or subguild.
 * @method getJobersInfo
 * @name Jobin.Jober.getJobersInfo
 * @param {ParseObject} jober (optional)
 * @returns {Array} All Jober Info.
 */
function _getGuildReviews() {
  _getGuildReviews = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(guildId) {
    var minStars,
      Guild,
      guild,
      Jobs,
      jobsQuerySub,
      jobsQueryM,
      jobsQuery,
      User,
      Review,
      reviewQuery,
      _args13 = arguments;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          minStars = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : 4;
          Guild = Parse.Object.extend("Verticales");
          guild = Guild.createWithoutData(guildId);
          Jobs = Parse.Object.extend("Jobs");
          jobsQuerySub = new Parse.Query(Jobs);
          jobsQuerySub.equalTo("Subvertical", guild);
          jobsQueryM = new Parse.Query(Jobs);
          jobsQueryM.equalTo("Vertical", guild);
          jobsQuery = Parse.Query.or(jobsQuerySub, jobsQueryM);
          User = Parse.Object.extend("User");
          new Parse.Query(User);
          Review = Parse.Object.extend("Review");
          reviewQuery = new Parse.Query(Review);
          reviewQuery.greaterThanOrEqualTo("Stars", minStars);
          reviewQuery.matchesQuery("Job", jobsQuery);
          reviewQuery.include(["User", "User.Name"]);
          _context13.prev = 16;
          _context13.next = 19;
          return reviewQuery.find();
        case 19:
          _context13.t0 = _context13.sent;
          return _context13.abrupt("return", {
            status: "ok",
            result: _context13.t0
          });
        case 23:
          _context13.prev = 23;
          _context13.t1 = _context13["catch"](16);
          console.error(_context13.t1);
          return _context13.abrupt("return", {
            status: "error",
            result: "Hubo un error y no hemos podido descargar las valoraciones. Inténtalo de nuevo."
          });
        case 27:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[16, 23]]);
  }));
  return _getGuildReviews.apply(this, arguments);
}
export function getJobersInfo(_x10) {
  return _getJobersInfo.apply(this, arguments);
}
function _getJobersInfo() {
  _getJobersInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(guildId) {
    var Guild, guildQuerySub, guild, guildQuery, guildQueryFinal, guildLine, User, userQuery, Jober, joberQuery, jobers, Task, taskQueryVertical, taskQueryType, taskFinal, tasks, result;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          Guild = Parse.Object.extend("Verticales");
          guildQuerySub = new Parse.Query(Guild);
          guildQuerySub.equalTo("objectId", guildId);
          guild = Guild.createWithoutData(guildId);
          guildQuery = new Parse.Query(Guild);
          guildQuery.equalTo("Father", guild);
          guildQueryFinal = Parse.Query.or(guildQuerySub, guildQuery);
          _context14.next = 10;
          return guildQueryFinal.first();
        case 10:
          guildLine = _context14.sent;
          User = Parse.Object.extend("User");
          userQuery = new Parse.Query(User);
          userQuery.equalTo("Active", true);
          userQuery.equalTo("Jober", true);
          userQuery.equalTo("Level", 3);
          userQuery.greaterThanOrEqualTo("Points", 4);
          Jober = Parse.Object.extend("Jober");
          joberQuery = new Parse.Query(Jober);
          joberQuery.matchesQuery("Jober", userQuery);
          _context14.next = 22;
          return joberQuery.find();
        case 22:
          jobers = _context14.sent;
          Task = Parse.Object.extend("Task");
          taskQueryVertical = new Parse.Query(Task);
          taskQueryVertical.equalTo("Vertical", guildLine);
          taskQueryType = new Parse.Query(Task);
          taskQueryType.equalTo("Type", guildLine.get("Type"));
          taskFinal = Parse.Query.or(taskQueryType, taskQueryVertical);
          taskFinal.containedIn("User", jobers.map(function (jober) {
            return jober.get("Jober");
          }));
          taskFinal.include(["User", "User.Name", "User.Points", "User.Tasks", "User.Thumbnail"]);
          _context14.next = 33;
          return taskFinal.find();
        case 33:
          tasks = _context14.sent;
          result = tasks.map(function (task) {
            var user = task.get("User");
            var joberDesc = jobers.find(function (jober) {
              return jober.get("Jober").id === user.id;
            });
            return {
              name: user ? user.get("Name") : undefined,
              points: user ? user.get("Points") : undefined,
              tasks: user ? user.get("Tasks") : undefined,
              thumbnail: user ? user.get("Thumbnail").url() : undefined,
              description: joberDesc.get("Description")
            };
          });
          return _context14.abrupt("return", {
            status: "ok",
            result: result
          });
        case 38:
          _context14.prev = 38;
          _context14.t0 = _context14["catch"](0);
          console.error(_context14.t0);
          return _context14.abrupt("return", {
            status: "error",
            result: "Hubo un error y no hemos podido descargar las valoraciones. Inténtalo de nuevo."
          });
        case 42:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[0, 38]]);
  }));
  return _getJobersInfo.apply(this, arguments);
}